import React from 'react'
import { useImmerStore } from '../../../store'

import { Box, Text } from '../../Shared/Base'
import { SvgIconGarbage, SvgIconHeart, SvgIconThumb } from '../../Shared/Svg/Alert'
import ResultContactInfo, { ResultContactInfoLegacy } from './ContactInfo'

const FavoriteButton = ({ is_favorite, onFavorite, onUnfavorite }) => {
  return (
    <>
      {is_favorite !== undefined && Boolean(is_favorite) && (
        <Box
          onClick={onUnfavorite}
          as="button"
          className="btn is-outlined is-tiny"
          display="flex"
          alignItems="center"
          justifyContent="center"
          width="100%"
        >
          <SvgIconHeart color={'var(--colorNegative)'} />
          <Box as="span" ml={15}>
            Enregistré
          </Box>
        </Box>
      )}
      {is_favorite !== undefined && !Boolean(is_favorite) && (
        <Box
          onClick={onFavorite}
          as="button"
          className="btn is-outlined is-tiny"
          display="flex"
          alignItems="center"
          justifyContent="center"
          width="100%"
        >
          <SvgIconHeart color={'var(--colorLight)'} />
          <Box as="span" ml={15}>
            Enregistrer
          </Box>
        </Box>
      )}
    </>
  )
}

const ContactExternal = ({
  owner_type,
  type,
  ad_id,
  ad_new_real_estate,
  expired,
  source,
  source_label,
  source_is_subscribed,
  source_has_contact,
  external_id,
  linkContact,
  is_favorite,
  nb_contacts,
  search_type,
  onClickReport,
  onFavorite,
  onUnfavorite
}) => {
  const [{ db }] = useImmerStore()
  const owner_particulier_label = search_type === 'for_rent' ? 'le propriétaire' : 'le vendeur'
  const owner_pro_label = type === 'Programme' ? 'le promoteur' : "l'agence"

  return (
    <>
      {expired ? (
        ad_new_real_estate ? (
          <>
            {' '}
            <Text color="negative" className="fz-24">
              Ce programme n'est plus disponible
            </Text>{' '}
          </>
        ) : (
          <>
            {' '}
            <Text color="negative" className="fz-24">
              Cette annonce n'est plus disponible.
            </Text>
          </>
        )
      ) : (
        <>
          <Text className="fz-24" display={{ md: 'block', xs: 'none' }}>
            {!Boolean(nb_contacts) || nb_contacts < 5
              ? 'Dépêchez-vous pour être parmi les premiers à contacter '
              : `Dépêchez-vous, ${nb_contacts} personnes ont déjà contacté `}{' '}
            {owner_type === 'Particulier' ? owner_particulier_label : owner_pro_label}
          </Text>
          {db.me_authenticated ? (
            <ResultContactInfo
              ad_id={ad_id}
              ad_new_real_estate={ad_new_real_estate}
              owner_type={owner_type}
              search_type={search_type}
              source={source}
              source_label={source_label}
            />
          ) : (
            <ResultContactInfoLegacy
              ad_id={ad_id}
              ad_new_real_estate={ad_new_real_estate}
              owner_type={owner_type}
              search_type={search_type}
              linkContact={linkContact}
              source={source}
              source_label={source_label}
              source_has_contact={source_has_contact || source_is_subscribed}
            />
          )}

          <Box
            display={{ md: 'flex', xs: 'none' }}
            alignItems="center"
            justifyContent="space-between"
            mt={30}
            style={{ gap: '25px' }}
          >
            <FavoriteButton
              is_favorite={is_favorite}
              onFavorite={onFavorite}
              onUnfavorite={onUnfavorite}
            />

            {onClickReport && (
              <Box
                as="button"
                className="btn is-outlined is-tiny"
                display={{ md: 'flex', xs: 'none' }}
                alignItems="center"
                justifyContent="center"
                onClick={onClickReport}
                width="100%"
              >
                <SvgIconGarbage />
                Supprimer
              </Box>
            )}
          </Box>
        </>
      )}
    </>
  )
}

const AlertResultContactZone = ({
  ad_id,
  ad_new_real_estate,
  owner_type,
  type,
  source,
  source_is_subscribed,
  source_has_contact,
  source_label,
  expired,
  linkContact,
  nb_contacts,
  onClickReport,
  is_favorite,
  search_type,
  onFavorite,
  onUnfavorite
}) => {
  return (
    <Box
      position={{ md: 'relative', xs: 'fixed' }}
      bottom={0}
      left={0}
      right={0}
      backgroundColor="white"
      border={{ md: '1px solid', xs: '0px solid' }}
      boxShadow={{
        md: '0px 5px 20px 5px rgba(0,0,0,0.05);',
        xs: '0px -30px 30px 5px rgba(0,0,0,0.03);'
      }}
      borderColor={{ md: 'thin', xs: 'thin' }}
      borderRadius={{ md: 5, xs: '0' }}
      textAlign="center"
      p={{ md: 30, xs: 20 }}
      zIndex={2}
    >
      <Box as="span" display={{ md: 'block', xs: 'none' }} mb={{ sm: 40, xs: 0 }}>
        <SvgIconThumb />
      </Box>

      <ContactExternal
        ad_id={ad_id}
        ad_new_real_estate={ad_new_real_estate}
        nb_contacts={nb_contacts}
        owner_type={owner_type}
        type={type}
        expired={expired}
        source={source}
        source_is_subscribed={source_is_subscribed}
        source_has_contact={source_has_contact}
        linkContact={linkContact}
        onClickReport={onClickReport}
        is_favorite={is_favorite}
        onFavorite={onFavorite}
        onUnfavorite={onUnfavorite}
        search_type={search_type}
        source_label={source_label}
      />
    </Box>
  )
}

export default AlertResultContactZone
